import React from 'react';

import { FulfillmentProviderLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

export const FulfillmentProvider = () => {
  const { fulfillmentProviderName } = useFulfillmentDisplayContext();

  return <ReadonlyField label={FulfillmentProviderLabel}>{fulfillmentProviderName}</ReadonlyField>;
};
